import styled from 'styled-components';

export const Container = styled.div<{ $containerHasTopPadding: boolean }>`
  ${({ $containerHasTopPadding }) => $containerHasTopPadding && `padding-top: 20px;`}
  & div[class*='LoadingContainer'] {
    height: fit-content;
    width: unset;
  }
`;
